export const mapHasLiveEvents = (league) => {
    league.hasLiveEvents = (league.liveFixturesTotalCount && league.liveFixturesTotalCount > 0) || (league.liveOutrightsTotalCount && league.liveOutrightsTotalCount > 0) || false;
};
//# sourceMappingURL=mapHasLiveEvents.js.map